import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const Item = (props) => {
  let deleted = false;
  let disableDeleteIngredient = props.disableDeleteIngredient;
  let inactiveLeftover = props.isLeftover && !props.item.active;
  if (props.isIngredient) {
    deleted = props.deletedIngredients.indexOf(props.item.id) > -1
  } else {
    deleted = props.deletedLeftovers.indexOf(props.item.id) > -1
  }
  let removedItem= deleted || inactiveLeftover ? {color: 'darkred'} : {}
  return(
    <tr>
      {props.isIngredient && (
        <td className="hidden-xxs-down">
          {!props.item.item.is_inventory_control?
            <span className="badge badge-pill badge-warning">MANUAL</span> :
            <span className="badge badge-pill badge-success">SCAN</span>
          }
        </td>
      )}
      <td>
        <NavLink to={`/inventory/${props.item.id}/`}>
          {props.item.id}
        </NavLink>
      </td>
      <td>
        <span style={removedItem}>{props.item.item.name} {deleted?' (removed)':''} {inactiveLeftover ? ' (inactive)':''}</span>

      </td>
      {!props.isLeftover && (
        <td className="hidden-xs-down">
          {props.item.number_items}
        </td>
      )}
      <td className="d-flex hidden-xs-down">
        <span>{props.item.weight}</span>
        <span className="measureUnit">
          <span className="ml-025 badge badge-pill badge-info">{props.item.item.measure_unit? props.item.item.measure_unit : 'kg'}</span>
        </span>
      </td>
      <td>
      {deleted ?
        <button className="btn btn-primary mr-0" onClick={()=>{props.onItemRemoveOrRestore(props.item.id, props.isIngredient)}}>
          <i className="fa fa-undo"></i>
        </button> :
        <button className="btn btn-danger mr-0" disabled={disableDeleteIngredient || inactiveLeftover} onClick={()=>{props.onItemRemoveOrRestore(props.item.id, props.isIngredient)}}>
          <i className="fa fa-trash"></i>
        </button>
      }
      </td>
    </tr>
  )
}

export default class EditSessionItems extends Component {

  render(){
    let amount, title;
    if(this.props.isIngredient){
      amount = 'Qty Taken';
      title = 'Edit ingredients';
    }else {
      amount = 'Qty Left';
      title = 'Edit leftovers';
    }
    return(
      <div className="card">
        <div className="card-header card-header-inverse">
          <h5 className="mb-0">{title}</h5>
        </div>
        <div className="card-block p-0 m-0">
        { this.props.items.length ?
          <table className="table table-striped table-hover mb-0">
            <thead>
              <tr>
                {this.props.isIngredient && (<th className="hidden-xxs-down">Type</th>)}
                <th className="hidden-xs-down">Inventory ID</th>
                <th className="hidden-sm-up">ID</th>
                <th>Item</th>
                {!this.props.isLeftover && (<th className="hidden-xs-down">Pieces</th>)}
                <th className="hidden-xs-down">{amount}</th>
                <th>Action</th>
              </tr>
            </thead>
              <tbody>
                {this.props.items.map((item,index)=>{
                  return(
                    <Item
                      item={item}
                      isIngredient={this.props.isIngredient}
                      isLeftover={this.props.isLeftover}
                      onItemRemoveOrRestore={this.props.onItemRemoveOrRestore}
                      disableDeleteIngredient={this.props.isIngredient ? this.props.deletedIngredients.length + 1 === this.props.items.length : false }
                      deletedIngredients={this.props.deletedIngredients}
                      deletedLeftovers={this.props.deletedLeftovers}
                      key={index}
                    />
                  )
                })}
              </tbody>
          </table>
         :
          <div className="empty-table"><span>Session without {this.props.isIngredient ? 'Ingredients' : 'Leftovers'}</span></div>
        }
      </div>
    </div>
    )
  }
}
